/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'

import { WidgetId } from 'features/types'
import { SocialWebSourcesWidget } from 'schemas/SocialWebSourcesWidgetSchema'
import { Dashboard } from 'schemas/DashboardSchema'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

import { useDashboardData, useDashboardWidgetSetting } from '../../../../hooks/useDashboardState'
import { getWidgetForDashboard } from '../../../../features/widget/asyncThunks'
import { createInsightCount } from '../../../../utils/runSearchUtil'
import { getInsightCategory } from '../../../../utils/viewOptionUtil'
import { toFilter } from '../../../../utils/widgetUtil'
import { getMeasureByCountTypeAndAnalysisType } from '../../../../utils/measureUtil'

const createSearch = (widgetSetting: SocialWebSourcesWidget, dashboardData: Dashboard) => {
  const filter = toFilter(widgetSetting)
  // FIXME: Not sure the impact, but some extra properties `widgetSetting.excludedTerms` that weren't exsit originally
  // originally this field is lost during `nb.dto.clone(dashboard)` process in `onSuccess_getDashboard_` in show.js

  const measure = getMeasureByCountTypeAndAnalysisType(
    widgetSetting.countType!,
    widgetSetting.analysisType!
  )

  const { id: dashboardId, name } = dashboardData
  return createInsightCount(
    dashboardId!,
    name!,
    widgetSetting.precision!,
    [widgetSetting.selectedTopic.topicId!],
    filter,
    measure,
    getInsightCategory(widgetSetting.viewOption!)
  )
}

const RunSearchEffect = ({
  widgetId,
  children
}: {
  widgetId: WidgetId
  children: React.ReactElement
}) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebSourcesWidget>(widgetId)
  const dashboardData = useDashboardData()
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const search = createSearch(widgetSetting, dashboardData!)

    dispatch(
      getWidgetForDashboard({
        searches: [search],
        widgetId: widgetSetting.widgetId!,
        timestamp: refreshTimestamp
      })
    )
  }, [widgetSetting, dashboardData, dispatch, refreshTimestamp])

  return children
}

export default RunSearchEffect
